/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import CommonObject from "@shared/CommonObject";
import BaseObject from "@shared/BaseObject";
import {isObject} from "@/utils/helpers";

export default class BaseCookie extends BaseObject{

    key: string = ""



	constructor(key: string) {
		super();
		this.$cookies = CommonObject.cookies
		this.key = key;
	}


	set(value, key){
		key = key || this.key
		let str = this.onBeforeSet(value)
		console.log("cookie save: value = ", value, ", str = ", str)
		this.$cookies.set(key, str)
	}
	setOnce(value, key){
		key = key || this.key
		if(!this.exists(key)){
			this.set(key, value)
		}
	}
	exists(key){
		key = key || this.key
		return this.$cookies.isKey(key)
	}
	save(value, key){
		key = key || this.key
		this.set(value, key)
	}
	get(key){
		key = key || this.key
		let value = this.onAfterGet(this.$cookies.get(key))
		console.log("cookie get: value = ", value)
		return value
	}
	getAndClear(key){
		key = key || this.key
		let value = this.get(key);
		this.$cookies.remove(key);
		return value
	}

	onBeforeSet(value){
		return isObject(value) ? JSON.stringify(value) : value
	}

	onAfterGet(value){
		console.log("BaseCookie: onAfterGet: value = ", value)
		try{
			value = JSON.parse(value)
		} catch (e) {
			console.warn(e)
		}
		return value
	}
}



